module.exports = __webpack_public_path__ + "images/psp/FeaturedContentImages/electric-related-1.webp";